import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { errorToast, successToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { unadmitGuest } from '../apiHelpers';

export const useUnadmitGuest = (reservationId: string) => {
  const { id: restaurantId } = useRestaurant();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      unadmitGuest({
        restaurantId,
        reservationId,
      }),
    onError: (error) => {
      if (error instanceof ApiError) {
        errorToast({
          message: `Failed to undo check-in: ${error.message}`,
        });
      } else {
        errorToast({
          message: 'Failed to undo check-in. Please try again.',
        });
      }
    },
    onSuccess: () => {
      successToast({ message: 'Check-in undone successfully.' });
      queryClient.invalidateQueries({
        queryKey: [
          'restaurants',
          restaurantId,
          'occupants',
          'reservation',
          reservationId,
        ],
      });
    },
  });
};
